import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberIterator'
})
export class NumberIteratorPipe implements PipeTransform {
  transform(value: number): number[] {
    return Array(value)
      .fill('')
      .map((_, index: number) => index + 1);
  }
}
